import { FC, HTMLAttributes, useEffect, useRef } from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface ISliderContainerProps {
  settings?: Settings;
  nbSlide: number;
  dotsClass?: string;
  activeSlide?: number;
  isHideDots?: boolean;
  afterChangeSlider?: (currentSlide: number) => void;
}

export const SliderContainer: FC<
  ISliderContainerProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const { settings, nbSlide, children, className, afterChangeSlider, activeSlide } = props;
  const slideRef = useRef<Slider>(null);
  useEffect(() => {
    if (activeSlide !== undefined) {
      slideRef.current?.slickGoTo(activeSlide);
    }
  }, [activeSlide]);

  const slideSetting = {
    afterChange: afterChangeSlider,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: nbSlide > 1,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    ...settings,
  };

  return (
    <Slider {...slideSetting} className={className} ref={slideRef}>
      {children}
    </Slider>
  );
};
